import React from 'react'

const Checkout = () => {
  return (
    <>
       <h2>Checkout page for placing order</h2>
      <div>Checkout Page creation under progress ...</div>
      <div>will add payment gateway integration, sum total amount</div>
    
    </>
    
  )
}

export default Checkout
